import {Component, OnInit, signal} from '@angular/core';
import {Functions} from "../../helpers/Functions";
import {CommunityDTO} from "../../DTO/CommunityDTO";
import {CommunityService} from "../../services/community/community.service";
import {ApiService} from "../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {ThemeService} from "../../services/theme/theme.service";
import {MetadataService} from "../../services/metadata.service";
import { communityModuleIdFromRoute } from './prior-appointment-route.util';
import { loadPreReservationLabelsForModule, preAppointmentI18nKey } from '../../services/prior-appointment/prior-appointment-labels.util';

@Component({
  selector: 'app-prior-appointment',
  templateUrl: './prior-appointment.component.html',
  styleUrl: './prior-appointment.component.scss'
})
export class PriorAppointmentComponent implements OnInit{
  communityName = "";
  community: CommunityDTO;
  communityModuleId: number | null = null;
  readonly preReservationLabels = signal(false);

  constructor( private apiService: ApiService,
               private actRoute: ActivatedRoute,
               private translate: TranslateService,
               private communityService: CommunityService,
               private themeService: ThemeService,
               private router: Router,
               private metadataService: MetadataService) {
  }

  private instantPa(key: string, params?: object): string {
    const resolved = this.preReservationLabels() ? preAppointmentI18nKey(key) : key;
    return this.translate.instant(resolved, params);
  }

  ngOnInit(): void {
    this.communityName = this.actRoute.snapshot.params['community'];
    this.communityModuleId = communityModuleIdFromRoute(this.actRoute);
    this.communityService.Get().subscribe(res=>{
      this.community = res;
      void loadPreReservationLabelsForModule(
        this.apiService,
        this.community,
        this.communityModuleId,
        this.preReservationLabels,
        () => this.communityModuleId
      ).then(() => {
        if (this.community) {
          this.metadataService.updateMetadata({
            title: Functions.decode(this.community.name) + ' - ' + this.instantPa('PRIORAPPOINTMENT.title'),
          });
        }
      });
    });
  }
  public newReservation(search?: boolean) {
    const mid = this.communityModuleId;
    if (mid == null) {
      return;
    }
    const queryParams = this.actRoute.snapshot.queryParams;
    if (search) {
      void this.router.navigate([this.communityName, 'prior-appointment', 'm', mid, 'detail'], { queryParams });
    } else {
      void this.router.navigate([this.communityName, 'prior-appointment', 'm', mid, 'new'], { queryParams });
    }
  }

}
